import TrackerFactory from './factories/TrackerFactory';
export function createSnowplowTracker({ id , platform , env , userID  }) {
    TrackerFactory.createTracker(id, platform, env, userID);
}
export function getSnowplowTracker(id) {
    return TrackerFactory.getTracker(id);
}

//# sourceMappingURL=HudlSnowplow.js.map